import { gql } from "@apollo/client"

export const GET_SEASONS = gql`
  query GetSeasons($filter: SeasonFilterFilter) {
    allSeasons(filter: $filter, orderBy: name_ASC, paginate: 9999) {
      id
      name
      description
      startDate
      endDate
      isActive
      isArchived
      sortOrder
      gameId
      rankingUrl
      totalTournaments
      Game {
        id
        name
        description
        image
        isActive
        urlImage
        urlIcon
        urlActiveSeason
      }
    }
  }
`

export const RANKING_LIST = gql`
  query RankingListV2($RankingListInput: RankingListInput!) {
    RankingListV2(input: $RankingListInput) {
      status {
        success
        name
        detail
      }
      total
      pages
      Ranking {
        id
        points
        totalTournaments
        victories
        draws
        defeats
        Person {
          id
          avatar
          fullName
          urlAvatar
          code
          countryId
          regionId
          locationId
        }
      }
    }
  }
`
